import React from 'react';

const Projects = ({
  data
}) => {
  if (data) {
    return (
      data.map((project, i) => (
        <div key={i} className="company--project">
          {project.screens.map((screen, index) =>
            <div key={index}>
              {screen.img ? (
                <img
                  src={screen.img}
                  alt=""
                  className={!screen.height ? 'w-100' : ''}
                  {...(screen.height ? { height: screen.height } : {})}
                />
              ) : ''}

              {screen.video ?
                <video width="400" controls>
                  <source src={screen.video} type="video/mov" />
                  Your browser does not support HTML5 video.
                </video>
                : ''}
              <p style={{ marginBottom: '3rem' }}>
                {screen.body}
              </p>
            </div>
          )}
        </div>
      ))
    )
  }
}

export default Projects